import React from 'react';

// ============================================================================
// INSTRUÇÕES PARA O SEU AMBIENTE LOCAL (localhost:3000):
// Para usar a sua imagem PNG oficial, basta descomentar as duas linhas abaixo
// e apagar a variável temporária de fallback "AgendexLogoLocal":
// ============================================================================
import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png';
const AgendexLogoLocal = AgendexLogo;

// Fallback temporário para evitar erros de compilação no Preview do Canvas
// const AgendexLogoLocal = null;

/**
 * AgendexBrandLogo - Componente de marca oficial, reutilizável e responsivo.
 * @param {string} subtitle - Subtítulo dinâmico (ex: "AGENDA DIGITAL", "ÁREA DO CLIENTE")
 * @param {boolean} showIcon - Define se exibe o ícone oficial da marca
 */
export default function AgendexBrandLogo({ subtitle = "AGENDA DIGITAL", showIcon = true }) {
    return (
        <div className="d-flex align-items-center gap-2 text-start select-none brand-logo-container">
            
            {/* ÍCONE DA LOGO OFICIAL */}
            {showIcon && (
                <div 
                    className="d-flex align-items-center justify-content-center"
                    style={{ 
                        width: '44px', 
                        height: '44px',
                    }}
                >
                    {AgendexLogoLocal ? (
                        /* Exibição da sua imagem PNG física real (Local Dev) */
                        <img 
                            src={AgendexLogoLocal} 
                            alt="Agendex Oficial Logo" 
                            style={{
                                height: '100%',
                                width: 'auto',
                                objectFit: 'contain',
                                filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.08))' 
                            }}
                        />
                    ) : (
                        /* Renderizador SVG sob medida de alta fidelidade (Fallback para o Canvas) 
                           Desenha exatamente a fita azul dobrada em forma de "A" da sua marca */
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style={{ width: '100%', height: '100%' }}>
                            <defs>
                                <linearGradient id="ribbonGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#258cc5" />
                                    <stop offset="100%" stopColor="#1a73a8" />
                                </linearGradient>
                                <linearGradient id="foldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#1c75ab" />
                                    <stop offset="100%" stopColor="#125680" />
                                </linearGradient>
                            </defs>
                            {/* Fita traseira / Esquerda e conexão horizontal */}
                            <path 
                                d="M25,145 L68,30 L95,30 L52,145 Z" 
                                fill="url(#ribbonGrad)" 
                            />
                            {/* Dobra central horizontal da fita */}
                            <path 
                                d="M78,145 L118,145 L94,80 L54,80 Z" 
                                fill="url(#ribbonGrad)" 
                                opacity="0.9"
                            />
                            {/* Fita frontal / Direita dobrada por cima */}
                            <path 
                                d="M68,30 L95,30 L175,158 L148,168 Z" 
                                fill="url(#foldGrad)" 
                                style={{ filter: 'drop-shadow(-2px 2px 3px rgba(0,0,0,0.15))' }}
                            />
                        </svg>
                    )}
                </div>
            )}

            {/* TEXTOS DA MARCA (Nome principal + Símbolo ® + Subtítulo) */}
            <div className="d-flex flex-column align-items-start justify-content-center">
                <div className="d-flex align-items-start position-relative">
                    <span 
                        className="text-dark" 
                        style={{ 
                            fontSize: '1.6rem', 
                            fontWeight: '800', 
                            lineHeight: '0.9',
                            letterSpacing: '-0.5px',
                            fontFamily: 'system-ui, -apple-system, sans-serif'
                        }}
                    >
                        Agendex
                    </span>
                    <sup 
                        className="text-primary fw-bold align-super ms-1" 
                        style={{ 
                            fontSize: '0.95rem', // era 0.65 rem
                            top: '-0.4em',
                            fontFamily: 'system-ui, -apple-system, sans-serif'
                        }}
                    >
                        ®
                    </sup>
                </div>

                <span 
                    className="text-muted fw-bold" 
                    style={{ 
                        fontSize: '0.55rem', 
                        letterSpacing: '1.5px', 
                        marginTop: '4px',
                        textTransform: 'uppercase',
                        lineHeight: '1',
                        fontFamily: 'system-ui, -apple-system, sans-serif'
                    }}
                >
                    {subtitle}
                </span>
            </div>
        </div>
    );
}


// import React from 'react';

/**
 * AgendexBrandLogo - Componente de marca reutilizável e responsivo.
 * @param {string} subtitle - Subtítulo dinâmico (ex: "AGENDA DIGITAL", "ÁREA DO CLIENTE")
 * @param {boolean} showIcon - Define se exibe o círculo com o ícone degradê da marca
 */
// export default function AgendexBrandLogo({ subtitle = "AGENDA DIGITAL", showIcon = true }) {
//     return (
//         <div className="d-flex align-items-center gap-2 text-start select-none brand-logo-container">
//             {}
//             {showIcon && (
//                 <div 
//                     className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold shadow-sm"
//                     style={{ 
//                         width: '44px', 
//                         height: '44px', 
//                         background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
//                         fontSize: '1.2rem'
//                     }}
//                 >
//                     {/* Aqui vai a letra estilizada ou o ícone físico futuramente */}
//                     <span style={{ transform: 'translateY(-1px)' }}>A</span>
//                 </div>
//             )}

//             {}
//             <div className="d-flex flex-column align-items-start justify-content-center">
//                 {/* Linha principal com o nome e o símbolo de Marca Registrada ® */}
//                 <div className="d-flex align-items-start position-relative">
//                     <span 
//                         className="text-dark" 
//                         style={{ 
//                             fontSize: '1.6rem', 
//                             fontWeight: '800', 
//                             lineHeight: '0.9',
//                             letterSpacing: '-0.5px'
//                         }}
//                     >
//                         Agendex
//                     </span>
//                     {/* O superscript (sup) eleva o símbolo. Usamos font-size pequeno para ficar discreto */}
//                     <sup 
//                         className="text-primary fw-bold align-super ms-1" 
//                         style={{ 
//                             fontSize: '0.65rem', 
//                             top: '-0.4em' 
//                         }}
//                     >
//                         ®
//                     </sup>
//                 </div>

//                 {}
//                 {/* Subtítulo rastreado (espaçado) e em caixa alta */}
//                 <span 
//                     className="text-muted fw-bold" 
//                     style={{ 
//                         fontSize: '0.55rem', 
//                         letterSpacing: '1.5px', 
//                         marginTop: '4px',
//                         textTransform: 'uppercase',
//                         lineHeight: '1'
//                     }}
//                 >
//                     {subtitle}
//                 </span>
//             </div>
//         </div>
//     );
// }